import weiser from "../../assets/img/weiser-logo.png";
import syncLogo from "../../assets/img/sync-logo.png";
import synctelLogo from "../../assets/img/synqtel-logo-login.png";
import futuresoftLogo from "../../assets/img/futuresoft-logo-login.png";

export function getAuthBrandConfig(subdomain) {
  const isSyncAfrica = subdomain === "synqafrica";
  const isSynqtel = subdomain === "synqtel";
  const isFuturesoft = subdomain === "futuresoft";

  return {
    logo: isSyncAfrica
      ? syncLogo
      : isSynqtel
      ? synctelLogo
      : isFuturesoft
      ? futuresoftLogo
      : weiser,
    name: isSyncAfrica
      ? "Synq Africa"
      : isSynqtel
      ? "Synqtel"
      : isFuturesoft
      ? "Futuresoft"
      : "Smartgate",
    useSmartgateMark: !isSyncAfrica && !isSynqtel && !isFuturesoft,
  };
}
